import { httpClient } from 'api';
import { ChatImage, ChatMessage, ChatThreadUnknown, ChatThreadWithMessage } from 'types/Chat';
import { ProgramMembership } from 'types/Membership';

export const chatApi = {
	getAccess: (programMembershipId: number) => httpClient.get<boolean>(`/chat/${programMembershipId}/access`),
	getStatus: (programMembershipId: number) => httpClient.get<number[]>(`/chat/${programMembershipId}/status`),
	getThreads: (programMembershipId: number) =>
		httpClient.get<ChatThreadWithMessage[]>(`/chat/${programMembershipId}/threads`),
	getThread: (programMembershipId: number, interlocutorMembershipId: number) =>
		httpClient.get<ChatThreadUnknown>(`/chat/${programMembershipId}/thread/${interlocutorMembershipId}`),
	getNewChatRequest: (programId: number, programMembershipId: number) =>
		httpClient.get<boolean>(`/chat/${programId}/new/${programMembershipId}`),
	getThreadMessages: (programMembershipId: number, threadId: number, lastMessageId?: number) =>
		httpClient.get<ChatMessage[]>(
			`/chat/${programMembershipId}/messages/${threadId}${lastMessageId ? `/${lastMessageId}` : ''}`
		),
	getUnthreadMembers: (programMembershipId: number) =>
		httpClient.get<ProgramMembership[]>(`/chat/${programMembershipId}/unthread-members`),
	sendChatMessage: (
		programMembershipId: number,
		interlocutorMembershipId: number,
		data: { message: string; localId: string; messageUuid: string; imageIds: number[] }
	) => httpClient.post<ChatMessage>(`/chat/${programMembershipId}/message/${interlocutorMembershipId}`, data),
	uploadChatImage: (
		programMembershipId: number,
		interlocutorMembershipId: number,
		data: FormData,
		options?: {
			signal?: AbortSignal;
			timeout?: number;
			onUploadProgress?: (event: any) => void;
		}
	) =>
		httpClient.post<ChatImage>(`/chat/${programMembershipId}/image/${interlocutorMembershipId}`, data, {
			...(options || {}),
			timeout: options?.timeout || 60000,
		}),
	deleteChatImage: (programMembershipId: number, imageId: number) =>
		httpClient.delete<boolean>(`/chat/${programMembershipId}/image/${imageId}`),
	cleanupDraftImages: (programMembershipId: number, messageUuid: string) =>
		httpClient.delete<boolean>(`/chat/${programMembershipId}/image/draft/${messageUuid}`),
	readThread: (programMembershipId: number, interlocutorMembershipId: number) =>
		httpClient.post<boolean>(`/chat/read/${programMembershipId}/${interlocutorMembershipId}`),
	deleteMessage: (
		membershipId: number,
		messageId: number
	): Promise<{
		success: boolean;
		wasSentAsReminder: boolean;
		wasRead: boolean;
	}> => httpClient.delete(`/chat/${membershipId}/messages/${messageId}`),

	// subs
	subChatThread: ({
		params,
		signal,
	}: {
		params: { programMembershipId: number; bump?: number };
		signal: AbortSignal;
	}) =>
		httpClient.subscribe<ChatThreadWithMessage>(
			`/chat/sub/chat-thread/${params.programMembershipId}`,
			// { bump: params.bump || 1 },
			{},
			{ signal }
		),
	subChatThreadSelf: ({
		params,
		signal,
	}: {
		params: { programMembershipId: number; bump?: number };
		signal: AbortSignal;
	}) =>
		httpClient.subscribe<ChatThreadWithMessage>(
			`/chat/sub/chat-thread-self/${params.programMembershipId}`,
			// { bump: params.bump || 1 },
			{},
			{ signal }
		),
	subChatMessage: ({
		params,
		signal,
	}: {
		params: { programMembershipId: number; interlocutorMembershipId: number; bump?: number };
		signal: AbortSignal;
	}) =>
		httpClient.subscribe<ChatMessage>(
			`/chat/sub/chat-message/${params.programMembershipId}/${params.interlocutorMembershipId}`,
			// { bump: params.bump || 1 },
			{},
			{ signal }
		),
};
